import React from 'react';
import AtlRankingTable from './AtlRankingTable';
import { EVENT_ASSIGNMENTS_TABLE_MODE } from './constants/EventAssignmentsTableMode';

/**
 * @typedef {object} AtlPreferenceTableProps
 * @property {Array<*>} [atlSponsorRankings]
 * @property {Array<*>} [atlPreferences]
 * @property {(selections: Object | ((prev: Object) => Object)) => void} [setSelections]
 * @property {boolean} [loading]
 */

/**
 * @param {AtlPreferenceTableProps} props
 */
const AtlPreferenceTable = props => {
  const { atlPreferences, atlSponsorRankings = [], setSelections, loading } = props;

  const atlRows = atlSponsorRankings.map(atl => ({
    ...atl,
    key: atl.externalUserId,
    assignmentRank:
      atlPreferences?.find(atlPreference => atlPreference.externalUserId === atl.externalUserId)
        ?.rank ?? null
  }));

  const setRankingValue = (externalUserId, rank) => {
    const updatedRankings = atlRows.map(x => ({
      externalUserId: x.externalUserId,
      rank: x.externalUserId === externalUserId ? rank : x.assignmentRank
    }));

    setSelections(prevState => ({
      ...prevState,
      atlPreferences: updatedRankings
    }));
  };

  return (
    <AtlRankingTable
      atlSponsorRankings={atlRows}
      mode={EVENT_ASSIGNMENTS_TABLE_MODE.ATL_PREFERENCES}
      setATLValue={setRankingValue}
      canEditRanking={true}
      loading={loading}
    />
  );
};

export default AtlPreferenceTable;
